export const userIdSelector = user => user.id;
export const userFirstNameSelector = user => user.firstName;
export const userLastNameSelector = user => user.lastName;
export const userEmailSelector = user => user.email;
export const activeCustomerEnvIdSelector = user => user.defaultCustomerEnvId;
export const userRoleSelector = user => user.role;
export const userMfaStatusSelector = user => user.mfaStatus;
